import { ENGLISH_DATE as e } from "../../../calendar-engine/use-cases/english_date/index.js";
import { ENGLISH_MONTHS as t, nepaliMonthMap as n } from "../../../calendar-engine/constants/calendar-date.js";
import "../../../calendar-engine/domains/index.js";
import { range as r } from "../../../calendar-engine/utilities/range.js";
import { stitch_date as i } from "../../../calendar-engine/utilities/stitch_date.js";
import { getSelectionAnchorDate as a, normalizeDisabledDates as o } from "../../../utilities/index.js";
import { get_year_list_in_decade_for_en_ctx as s, parseSafeDate as c, validate as l } from "../../../utilities/utils.js";
import { ad2bs as u } from "../../../calendar-carburettor/converter/index.js";
import { zero_pad as d } from "../../../calendar-carburettor/zero-pad/index.js";
import { ErrorMessage as f } from "../../config/index.js";
import { ModeEnum as p, ViewModeEnum as m } from "../../models/model.js";
import h from "dayjs";
import { englishToNepaliNumber as g } from "nepali-number";
// src/design/forms/datepicker/core/libs/strategy/english-strategy.ts
var _ = h().format("YYYY-MM-DD"), v = u, y = {
	setWeeks: () => {},
	setDate: (e) => (t, n) => {
		t.next[t.next.currentDateSelection] = e, n();
	},
	setDateForTypingEvent: (e) => (t, n) => {
		t.next[t.next.currentDateSelection] = e, n();
	},
	setConvertedDate: (e) => (t, n) => {
		let r = e;
		t.next.mode === p.RANGE ? (t.next.startDate = c(r.startDate), t.next.endDate = c(r.endDate)) : t.next.startDate = c(r.startDate), n();
	},
	setCalendarReferenceDate: () => function(e, t) {
		let n = a(e.next);
		e.next.calendarReferenceDate = n ? b(n) : _, t();
	},
	setDisableDateBefore: (e) => (t, n) => {
		(e.length >= 10 || e.length === 0) && (t.next.disableDateBefore = e ? h(e).format("YYYY-MM-DD") : ""), n();
	},
	setDisableDateAfter: (e) => (t, n) => {
		(e.length >= 10 || e.length === 0) && (t.next.disableDateAfter = e ? h(e).format("YYYY-MM-DD") : ""), n();
	},
	setIsTodayValid: (e) => (t, n) => {
		let r = t.next.disableDateBefore, i = t.next.disableDateAfter;
		if (p.RANGE === t.next.mode) {
			let e = o({
				startDate: t.next.startDate,
				endDate: t.next.endDate
			}, {
				disableDateBefore: t.next.disableDateBefore,
				disableDateAfter: t.next.disableDateAfter
			}, t.next.currentDateSelection);
			r = e.disableDateBefore, i = e.disableDateAfter;
		}
		let a = l(e, r, i);
		t.next.isTodayValid = a.is_valid, n();
	},
	setGridDatesWithMeta: (i, a) => {
		let s = e.get_weeks_in_month(new Date(i.next.calendarReferenceDate)), c = i.next.disableDateBefore, l = i.next.disableDateAfter;
		if (p.RANGE === i.next.mode) {
			let e = o({
				startDate: i.next.startDate,
				endDate: i.next.endDate
			}, {
				disableDateBefore: i.next.disableDateBefore,
				disableDateAfter: i.next.disableDateAfter
			}, i.next.currentDateSelection);
			c = e.disableDateBefore, l = e.disableDateAfter;
		}
		let u = r(0, s - 1), d = r(1, 7), f = u.map((t) => d.map((n) => e.get_day_info({
			weekNum: t,
			weekDayNum: n,
			calendarReferenceDate: i.next.calendarReferenceDate,
			date: i.next[i.next.currentDateSelection],
			disable_date_before: c,
			disable_date_after: l,
			disabledWeekDays: i.next.disabledWeekDays,
			holidays: i.next.holidays,
			weekSelectionEnabled: i.next.mode === p.WEEK,
			weekAnchorDate: i.next.startDate
		})));
		i.next.gridDatesWithMeta.gridDates = f;
		let [m, g] = i.next.calendarReferenceDate.split("-");
		i.next.gridDatesWithMeta.primaryYear = +m, i.next.gridDatesWithMeta.primaryMonth = t[g - 1];
		let _ = new Date(i.next.calendarReferenceDate);
		if (h("2033-04-15").isBefore(i.next.calendarReferenceDate)) i.next.gridDatesWithMeta.secondaryYear = -1, i.next.gridDatesWithMeta.secondaryMonthCombination = n[_.getMonth()];
		else {
			let e = v(i.next.calendarReferenceDate), [t] = e ? e.split("-") : [];
			i.next.gridDatesWithMeta.secondaryYear = +t, i.next.gridDatesWithMeta.secondaryMonthCombination = n[_.getMonth()];
		}
		a();
	},
	setMonthYearPanelData: function(e, t) {
		if (e.next.isOpen) {
			let r = new Date(e.next.calendarReferenceDate);
			if (h("2033-04-15").isBefore(e.next.calendarReferenceDate)) {
				e.next.monthYearPanelData = "-", t();
				return;
			}
			let i = v(e.next.calendarReferenceDate), a = i ? i.split("-") : [], o = g(a[0]);
			e.next.monthYearPanelData = `${n[r.getMonth()]} ${o}`;
		}
		t();
	},
	setCalendarControllerLabels: function(e, n) {
		if (e.next.isOpen) {
			let [n, r] = e.next.calendarReferenceDate.split("-");
			e.next.controllerLabel.month = t[r - 1], e.next.controllerLabel.year = n;
		}
		n();
	},
	incrementMonth: function(e, t) {
		e.next.calendarReferenceDate = h(e.next.calendarReferenceDate).add(1, "month").format("YYYY-MM-DD"), t();
	},
	decrementMonth: function(e, t) {
		e.next.calendarReferenceDate = h(e.next.calendarReferenceDate).subtract(1, "month").format("YYYY-MM-DD"), t();
	},
	incrementYear: function(e, t) {
		e.next.calendarReferenceDate = h(e.next.calendarReferenceDate).add(1, "year").format("YYYY-MM-DD"), t();
	},
	decrementYear: function(e, t) {
		e.next.calendarReferenceDate = h(e.next.calendarReferenceDate).subtract(1, "year").format("YYYY-MM-DD"), t();
	},
	incrementDecade: function(e, t) {
		e.next.calendarReferenceDate = h(e.next.calendarReferenceDate).add(10, "year").format("YYYY-MM-DD"), t();
	},
	decrementDecade: function(e, t) {
		e.next.calendarReferenceDate = h(e.next.calendarReferenceDate).subtract(10, "year").format("YYYY-MM-DD"), t();
	},
	setTodayAsDate: (e) => function(t, n) {
		t.next.mode === p.WEEK ? (t.next.startDate = h(e).startOf("week").format("YYYY-MM-DD"), t.next.endDate = h(e).endOf("week").format("YYYY-MM-DD")) : t.next.currentDateSelection === "startDate" ? t.next.startDate = e : t.next.endDate = e, n();
	},
	setTodayAsCalendarReferenceDate: function(e, t) {
		e.next.calendarReferenceDate = _, t();
	},
	setViewModeToMonth: function(e, t) {
		e.next.viewMode = m.MONTH_VIEW, t();
	},
	setViewModeToYear: function(e, t) {
		e.next.viewMode = m.YEAR_VIEW, t();
	},
	setViewModeToCalendar: function(e, t) {
		e.next.viewMode = m.CALENDAR_VIEW, t();
	},
	setGridYears: function(e, t) {
		let n = +e.next.calendarReferenceDate.split("-")[0], r = s(n);
		e.next.gridYears = [], e.next.gridYears = [
			r[0] - 1,
			...r,
			r[r.length - 1] + 1
		], t();
	},
	updateGridYearWithNextDecade: function(e, t) {
		let n = e.next.gridYears[e.next.gridYears.length - 1], r = s(n);
		e.next.gridYears = [], e.next.gridYears = [
			r[0] - 1,
			...r,
			r[r.length - 1] + 1
		], t();
	},
	updateGridYearWithPreviousDecade: function(e, t) {
		let n = e.next.gridYears[0], r = s(n);
		e.next.gridYears = [], e.next.gridYears = [
			r[0] - 1,
			...r,
			r[r.length - 1] + 1
		], t();
	},
	selectYear: (e) => (t, n) => {
		let r = i({
			year: e,
			month: +t.next.calendarReferenceDate.split("-")[1],
			day: 1
		}, "-");
		t.next.calendarReferenceDate = r, n();
	},
	selectMonth: (e) => (t, n) => {
		let r = i({
			year: +t.next.calendarReferenceDate.split("-")[0],
			month: e,
			day: 1
		}, "-");
		t.next.calendarReferenceDate = r, n();
	},
	closeCalendarPicker: function(e, t) {
		e.next.closeOnSelect && (e.next.isOpen = !1), t();
	},
	checkIfTodayIsValid: function(e, t) {
		l(_, e.next.disableDateBefore, e.next.disableDateAfter).is_valid && t();
	},
	checkIfDateIsValid: function(e, t) {
		let n = l(e.next?.[e.next.currentDateSelection], e.next.disableDateBefore, e.next.disableDateAfter);
		n.is_valid ? (e.next.error = "", e.next?.onError?.(""), t()) : (e.next.error = n.message, e.next?.onError?.(n.message), t());
	},
	checkIfStartDateIsBeforeEndDate: function(e, t) {
		if (e.next.mode === p.SINGLE) return t();
		let n = e.next.startDate, r = e.next.endDate;
		if (n && r) {
			if (n === r) {
				e.next.error = "", e.next?.onError?.(""), t();
				return;
			}
			h(n).isBefore(h(r)) ? (e.next.error = "", e.next?.onError?.("")) : (e.next.error = f.START_AND_END_DATE_BOUNDS, e.next?.onError?.(f.START_AND_END_DATE_BOUNDS));
		}
		t();
	},
	convertdatesToCurrentContext: function(e, t) {
		t();
	},
	setGridMonths: function(e, n) {
		e.next.gridMonths = t, n();
	},
	sendChanges: (e, t) => {
		e.next.mode === p.RANGE || e.next.mode === p.WEEK ? e?.next?.onChange?.({
			startDate: e.next.startDate,
			endDate: e.next.endDate
		}) : e?.next?.onChange?.(e.next.startDate), t();
	},
	sendWeekChanges: function(e, t) {
		e.next.onChange?.({
			startDate: h(e.next.startDate).startOf("week").format("YYYY-MM-DD"),
			endDate: h(e.next.startDate).endOf("week").format("YYYY-MM-DD")
		}), t();
	},
	normalizeDates: function(e, t) {
		t();
	},
	setStartAndEndDate: (e, t) => (n, r) => {
		n.next.startDate = e, n.next.endDate = t, r();
	},
	setYearGridDates: (t, n) => {
		if (t.next.isOpen) {
			let n = t.next.disableDateBefore, i = t.next.disableDateAfter;
			if (p.RANGE === t.next.mode) {
				let e = o({
					startDate: t.next.startDate,
					endDate: t.next.endDate
				}, {
					disableDateBefore: t.next.disableDateBefore,
					disableDateAfter: t.next.disableDateAfter
				}, t.next.currentDateSelection);
				n = e.disableDateBefore, i = e.disableDateAfter;
			}
			let [a] = _.split("-"), s = Array.from({ length: 12 }, (e, t) => `${a}-${d(t + 1)}-01`);
			t.next.yearGridDates = [], s.forEach((a) => {
				let o = e.get_weeks_in_month(new Date(a)), s = r(0, o - 1), c = r(1, 7);
				t.next.yearGridDates.push(s.map((r) => c.map((o) => e.get_day_info({
					weekNum: r,
					weekDayNum: o,
					calendarReferenceDate: a,
					date: t.next[t.next.currentDateSelection],
					disable_date_before: n,
					disable_date_after: i,
					disabledWeekDays: t.next.disabledWeekDays,
					holidays: t.next.holidays,
					weekSelectionEnabled: t.next.mode === p.WEEK,
					weekAnchorDate: t.next.startDate
				}))));
			});
		}
		n();
	},
	setYearGridDatesWithMeta: (i, a) => {
		if (i.next.isOpen) {
			let a = i.next.disableDateBefore, s = i.next.disableDateAfter;
			if (p.RANGE === i.next.mode) {
				let e = o({
					startDate: i.next.startDate,
					endDate: i.next.endDate
				}, {
					disableDateBefore: i.next.disableDateBefore,
					disableDateAfter: i.next.disableDateAfter
				}, i.next.currentDateSelection);
				a = e.disableDateBefore, s = e.disableDateAfter;
			}
			let [c] = i.next.calendarReferenceDate.split("-"), l = Array.from({ length: 12 }, (e, t) => `${c}-${d(t + 1)}-01`);
			i.next.yearGridDatesWithMeta = [], l.forEach((o) => {
				let c = e.get_weeks_in_month(new Date(o)), l = r(0, c - 1), u = r(1, 7), d = l.map((t) => u.map((n) => e.get_day_info({
					weekNum: t,
					weekDayNum: n,
					calendarReferenceDate: o,
					date: i.next[i.next.currentDateSelection],
					disable_date_before: a,
					disable_date_after: s,
					disabledWeekDays: i.next.disabledWeekDays,
					holidays: i.next.holidays,
					weekSelectionEnabled: i.next.mode === p.WEEK,
					weekAnchorDate: i.next.startDate
				}))), [f, m] = o.split("-"), g = new Date(o), _ = -1, y = "-";
				if (!h("2033-04-15").isBefore(o)) {
					let e = v(o), [t] = e ? e.split("-") : [];
					_ = +t, y = n[g.getMonth()];
				}
				let b = {
					gridDates: d,
					primaryYear: +f,
					primaryMonth: t[m - 1],
					secondaryYear: _,
					secondaryMonthCombination: y
				};
				i.next.yearGridDatesWithMeta.push(b);
			});
		}
		a();
	}
}, b = (e) => {
	e = e.toString().replace(/-/g, "");
	let t, n = "01", r = "01";
	if (e.length === 4) t = e;
	else if (e.length === 6) t = e.substring(0, 4), n = e.substring(4, 6);
	else if (e.length === 8) t = e.substring(0, 4), n = e.substring(4, 6), r = e.substring(6, 8);
	else return e;
	return isNaN(+t) || t.length !== 4 ? e : isNaN(+n) || +n < 1 || +n > 12 ? "Invalid month" : isNaN(+r) || +r < 1 || +r > 31 ? e : (n.length === 1 && (n = "0" + n), r.length === 1 && (r = "0" + r), `${t}-${n}-${r}`);
};
export { y as EnglishStrategy, b as completeDate };

//# sourceMappingURL=english-strategy.js.map